import Vue from "vue";
import Router from "vue-router";
import home from "./home.vue";
import login from "./login.vue";
import about from "./views/about.vue";
import Attendance from "./views/Attendance.vue";
import StudentView from "./views/StudentView.vue";
import Approval from "./views/Approval.vue";
import ApprovalView from "./views/ApprovalView.vue";
import Batch from "./views/Batch.vue";
import BatchView from "./views/BatchView.vue";
import reports from "./views/reports.vue";
import test from "./views/test.vue";
import tests from "./views/tests.vue";
import successfulTest from "./views/successfulTest.vue";
import signout from "./views/signout.vue";
import utils from "./utils";
import store from "./store";
//#TODO change imports into dynamic ones

Vue.use(Router);

const routes = [
  {
    path: "/main",
    name: "home",
    component: home,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        component: about
      },
      {
        path: "attendance",
        name: "attendance",
        props: true,
        component: Attendance
      },
      {
        path: "student/:id",
        name: "student",
        props: true,
        component: StudentView
      },
      {
        path: "approvals",
        name: "approvals",
        props: true,
        component: Approval,
        meta: { requiresAuth: true, donor: true }
      },
      {
        path: "approval/:id",
        name: "approval",
        props: true,
        component: ApprovalView,
        meta: { requiresAuth: true, donor: true }
      },
      {
        path: "batches",
        name: "batches",
        props: true,
        component: Batch
      },
      {
        path: "batch/:id",
        name: "batch",
        props: true,
        component: BatchView
      },
      {
        path: "reports",
        props: true,
        component: reports
      },
      {
        path: "test/:set/:lang/:id",
        name: "test",
        props: true,
        component: test
      },
      {
        path: "tests",
        name: "tests",
        component: tests
      },
      {
        path: "testsuccess/:id",
        name: "testsuccess",
        props: true,
        component: successfulTest
      },
      {
        path: "about",
        props: true,
        component: about
      }
    ]
  },
  {
    path: "/signout",
    name: "Signout",
    component: signout
  },
  {
    path: "/signin",
    name: "Login",
    component: login
  }
];

const router = new Router({
  routes,
  mode: "history",
  linkActiveClass: "active"
});

/**
 * It fires before going to any route.
 * We are getting current user from store and also localstorage
 * after getting user info we get role of user from state object
 * Then we will check if the role is donor and allow donor specific
 * urls for donor otherwise redirect to main page.
 * If user is not logged in then redicrect to login page
 *
 * @param {Route} to
 * @param {Route} from
 * @param {*} next
 */
const lStore = store;
function beforeEach(to, from, next) {
  let currentUser = utils.getCurrentUser(router, lStore);
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  let isDonor = to.matched.some(record => record.meta.donor);

  if (requiresAuth && !currentUser) {
    next({ name: "Login" });
  } else {
    if (isDonor) {
      var user = lStore.getters.get_login_details;
      //#TODO change to enums
      if (user.role === "donor") {
        next();
      } else {
        //#TODO change to named paths
        next("/main");
      }
    } else {
      next();
    }
  }
}

router.beforeEach(beforeEach);

export default router;
